import { Button, Flex } from "antd"
import PropTypes from "prop-types"
import { spacings } from "themes/variables"
import CustomDrawer from "ui/Drawer"

const actions = [
  {
    label: "View",
    color: "primary",
    variant: "outlined",
    onClick: () => {}
  },
  {
    label: "Edit",
    color: "primary",
    variant: "outlined",
    onClick: () => {}
  },
  {
    label: "Add to Group",
    color: "primary",
    variant: "outlined",
    onClick: () => {}
  },
  {
    label: "Remove from Group",
    color: "primary",
    variant: "outlined",
    onClick: () => {}
  },
  {
    label: "Message",
    color: "primary",
    variant: "outlined",
    onClick: () => {}
  },
  {
    label: "Text",
    color: "primary",
    variant: "outlined",
    onClick: () => {}
  },
  {
    label: "Delete",
    color: "danger",
    variant: "outlined",
    onClick: () => {}
  }
]

const moreActions = [
  {
    label: "Manage Groups",
    color: "primary",
    variant: "outlined",
    onClick: () => {}
  }
]

const chooseActionType = {
  actions,
  moreActions
}

const ActionDrawers = ({ actionType = "actions", open, setOpen }) => {
  const actions = chooseActionType[actionType] || []
  return (
    <CustomDrawer open={open} setOpen={setOpen} title="More Actions">
      <Flex vertical gap={spacings.M}>
        {actions.map((action) => (
          <Button
            key={action.label}
            color={action.color}
            variant={action.variant}
            className={`w-full py-l ${actions.length === 1 ? "my-5xl" : ""}`}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        ))}
      </Flex>
    </CustomDrawer>
  )
}

ActionDrawers.propTypes = {
  actionType: PropTypes.oneOf(["actions", "moreActions"]),
  open: PropTypes.bool,
  setOpen: PropTypes.func
}

export default ActionDrawers
